import { createSlice } from '@reduxjs/toolkit';

const stopSelectedChannelLoader = createSlice({
  name: 'stopSelectedChannelLoader', 
  initialState: {
    stopChannelLoader: false,
  },
  reducers: {
    stopSelectedChannelsLoader: (state,action) => {
      state.stopChannelLoader = action?.payload;
    },
  },
});

export default stopSelectedChannelLoader.reducer;
export const { stopSelectedChannelsLoader } = stopSelectedChannelLoader.actions;
